"use strict";

/**
 * Cache DOM selectors
 */
var $root = $('html');
var $header = $root.find('header');
var $mobileNavigation = $header.find('.mobile-navigation-wrapper');
var $navigationToggle = $header.find('.navigation-toggle');
var $navigationClose = $header.find('.navigation-close');
var $navigationBar = $header.find('.navigation-bar');
var $wrapper = $root.find('main');
var $galleryWrapper = $root.find('.gallery-wrapper');
var $galleryPrev = $galleryWrapper.find('.previous');
var $galleryNext = $galleryWrapper.find('.next'); // check if scrolling up or down

if (document.querySelector('.gallery-wrapper')) {
  window.galleryWrapper = document.querySelector('.gallery-wrapper');
} else {
  window.galleryWrapper = undefined;
}

window.lastGalleryElement = false;

function srollUpDown() {
  var lastSlide = false;
  window.scrollDirection = '';
  window.scroll = '';
  var lastScrollTop = 0;
  window.timeoutid = null;
  window.lastScrollTime = performance.now() / 1000;
  window.onmousewheel = function (event) {
    // window.galleryWrapper.addEventListener(
    //   'mousewheel',
    //   function (event) {
    //console.log(event);
    var currentScrollTime = performance.now() / 1000; //

    event.preventDefault(); //event.stopPropogation();
    //console.log('x ' + event['wheelDeltaX']);
    //console.log('y ' + event['wheelDeltaY']);

    if (currentScrollTime - window.lastScrollTime > 0.60) {
      // vertical scrolling
      window.lastScrollTime = currentScrollTime;

      if (event['wheelDeltaY'] < -5) {
        // console.log('up');
        $galleryWrapper.flickity('next', false, false);
      } else if (event['wheelDeltaY'] > 5) {
        // console.log('down');
        $galleryWrapper.flickity('previous', false, false);
      } // horizontal scrolling


      if (event['wheelDeltaX'] < -5) {
        // console.log('up');
        $galleryWrapper.flickity('next', false, false);
      } else if (event['wheelDeltaX'] > 5) {
        // console.log('down');
        $galleryWrapper.flickity('previous', false, false);
      }
    } // // stop listener if last slide is active
    // // not production ready! but there if needed in the future
    //  console.log(window.lastGalleryElement);
    //  if (window.lastGalleryElement === true) {
    // 	lastSlide = true;
    // }

  }, {
    passive: false
  }; // 	);
  // }
}

;
/**
 * Event: Window pageshow
 */

$(window).on('pageshow', function () {
  var logoInit = document.querySelector('.logo');
  logoInit.style.transition = '0.5s ease-in-out';
  logoInit.style.opacity = '1'; // Show wrapper once page is loaded

  $wrapper.addClass('loaded'); // Lazy load images

  $('.lazy-wrapper').find('img').unveil(0, function () {
    $(this).on('load', function () {
      $(this).parent('.lazy-wrapper').addClass('loaded');
    });
  }); // Call flickity slideshow plugin

  if ($galleryWrapper.children().length > 0) {
    $galleryWrapper.flickity({
      setGallerySize: false,
      pageDots: false,
      lazyLoad: 5,
      selectedAttraction: 0.2,
      friction: 0.9,
      freeScroll: true,
      contain: true,
      cellAlign: 'left',
      hash: true,
      prevNextButtons: !/iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
      on: {
        staticClick: function staticClick(e) {
          // Make slides clickable
          var index = $(e.target).index();

          if ($(e.target).parent().hasClass('gallery-element-video')) {
            index = $(e.target).parent().index();
          }

          if (!$(e.target).hasClass('flickity-viewport') && !$(e.target).hasClass('flickity-slider')) {
            $galleryWrapper.flickity('select', index);
          }
        },
        ready: function ready(e) {
          $(window).scrollTop(0); // Set buttons

          $galleryPrev = $galleryWrapper.find('.previous');
          $galleryNext = $galleryWrapper.find('.next'); // Add previous gallery link to slideshow if first slide is active

          if ($('.is-selected').attr('id') === 'slide-0') {
            $galleryPrev.attr('disabled', false).addClass('previous-gallery');
            $galleryPrev.bind('click', function () {
              document.querySelector('.prev-link').click();
            });
          } // Add next gallery link to slideshow if last slide is active


          if ($('.is-selected').attr('id') === 'slide-' + ($galleryWrapper.children().length - 1)) {} // Reload slideshow


          $('iframe').on('load', function () {
            $galleryWrapper.flickity('reloadCells');
          });
        }
      }
    }); // Disable vertical scroll on mobile devices when swiping through gallery

    $galleryWrapper.on('dragMove.flickity', function (event, pointer) {
      document.ontouchmove = function (e) {
        e.preventDefault();
      };
    });
    $galleryWrapper.on('dragEnd.flickity', function (event, pointer) {
      document.ontouchmove = function (e) {
        return true;
      };
    }); // Add previous and next gallery links to slideshow after change

    $galleryWrapper.on('settle.flickity', function (event, index) {
      if (index === 0) {
        $galleryPrev.attr('disabled', false).addClass('previous-gallery');
        $galleryPrev.bind('click', function () {
          document.querySelector('.prev-link').click();
        });
      } else {
        $galleryPrev.removeClass('previous-gallery');
        $galleryPrev.unbind('click');
      }

      if (index === $galleryWrapper.find('.flickity-slider').children().length - 1) {
        $galleryNext.attr('disabled', false).addClass('next-gallery');
        $galleryNext.bind('click', function () {
          document.querySelector('.next-link').click();
        });
        window.lastGalleryElement = true;
      } else {
        $galleryNext.removeClass('next-gallery');
        $galleryNext.unbind('click');
      }
    });
  } // Toggle mobile menu


  $navigationToggle.on('click', function () {
    $mobileNavigation.addClass('visible');
  });
  $navigationClose.on('click', function () {
    $mobileNavigation.removeClass('visible');
  });
  $header.on('click', function (e) {
    e.stopPropagation();
  });
  $root.on('click', function (e) {
    if ($mobileNavigation.hasClass('visible')) {
      $mobileNavigation.removeClass('visible');
    }
  }); // Call fitVids plugin

  $('.gallery-element-video').fitVids();
  $('.video').fitVids(); // Scroll to top if navigation bar is clicked

  $navigationBar.on('click', function () {
    $root.stop().animate({
      scrollTop: 0
    }, 300);
  });
  $navigationBar.children().on('click', function (e) {
    e.stopPropagation();
  });

  if (document.querySelector('.gallery-wrapper')) {
    srollUpDown();
  }
});
/**
 * Event: Window resize
 */

$(window).on('resize', function () {});
/**
 * Event: Window resize
 */

$(document).on('scroll', function () {
  // Toggle navigation bar
  if ($(window).scrollTop() > $header.outerHeight()) {
    $navigationBar.addClass('visible');
  } else {
    $navigationBar.removeClass('visible');
  }
});
/**
 * Functions
 */